var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesktopClassic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "desktop-classic",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "svg-fill"
  }, /*#__PURE__*/React.createElement("path", {
    className: "svg-fill",
    d: "M6 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H6Zm0 2h12v8H6V4ZM4 15a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H4Zm4 2h12v3H8v-3Zm1 .75v1.5h4v-1.5H9Zm6 0v1.5h4v-1.5h-4Z",
    fill: "#605E5C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopClassic);
export default __webpack_public_path__ + "static/media/desktop-classic.583475dcead121837ef10d0513e79cf3.svg";
export { ForwardRef as ReactComponent };